import { render, staticRenderFns } from "./AccountsTab.vue?vue&type=template&id=74a029a4&scoped=true&"
import script from "./AccountsTab.vue?vue&type=script&lang=js&"
export * from "./AccountsTab.vue?vue&type=script&lang=js&"
import style0 from "./AccountsTab.vue?vue&type=style&index=0&id=74a029a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a029a4",
  null
  
)

export default component.exports